/**
 * Компонент индикатора загрузки (спиннер)
 */

import React from 'react';
import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  inline?: boolean;
}

/**
 * Универсальный спиннер загрузки
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  text,
  inline = false,
}) => {
  return (
    <div className={`${styles.container} ${inline ? styles.inline : ''}`}>
      <div className={`${styles.spinner} ${styles[size]}`}>
        <div className={styles.bounce1}></div>
        <div className={styles.bounce2}></div>
        <div className={styles.bounce3}></div>
      </div>
      {text && <div className={styles.text}>{text}</div>}
    </div>
  );
};

/**
 * Overlay спиннер для форм
 */
export const LoadingOverlay: React.FC<{ text?: string }> = ({ text }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.overlayContent}>
        <LoadingSpinner size="large" text={text || 'Загрузка...'} />
      </div>
    </div>
  );
};
